(function($)
{
    $.extend(true, orion, {
        api: {
            checkout: {
                orderitems: {}
            }
        }
    });

    var
        api = orion.api.checkout.orderitems,
        uri = '/api-checkout/orderitems';

    function readMarkup(data)
    {
        var
            promise = $.ajax(uri + '/' + data.productNumber + '.html', {
                // "cache": false,
                'method': 'GET'
            });

        return promise;
    }

    api.readMarkup = readMarkup;
})(jQuery);
